import {
  darkThemeSelectStyles,
  SelectOptionWithCheck,
} from "../../../../components";

/** Analysis Builder react-select custom components (checkbox-style options). */
export const REPORT_BUILDER_SELECT_COMPONENTS = {
  Option: SelectOptionWithCheck,
} as const;

/**
 * Analysis Builder mode select styles.
 * Used by DefinePlayerDataSet, GlobalReportSettings, and ReportSectionCard.
 */
export const getReportBuilderSelectStyles = () => ({
  ...darkThemeSelectStyles,
  control: (provided: any, state: any) => ({
    ...darkThemeSelectStyles.control(provided, state),
    backgroundColor: "#252527",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    borderRadius: "6px",
    height: "38px",
    minHeight: "38px",
    borderColor: "rgba(255,255,255,0.1)",
    borderWidth: "1px",
    "&:hover": {
      borderColor: "#fb6a07",
    },
  }),
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: "#1d1d1f",
    borderRadius: "6px",
    border: "1px solid rgba(255,255,255,0.1)",
    zIndex: 50,
  }),
  option: (provided: any, state: any) => ({
    ...darkThemeSelectStyles.option(provided, state),
    backgroundColor: state.isSelected
      ? "#2A2A2C"
      : state.isFocused
        ? "#2A2A2C"
        : "#1D1D1F",
    color: "#f7f7f9",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#2A2A2C",
    },
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: "#fff",
    fontSize: "14px",
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#9ca3af",
    fontSize: "14px",
  }),
});

export interface FreeformSelectStylesOptions {
  /** Include option overrides (selected/focus colors). PlayerSelectStep uses true; MovementTypeStep uses false. */
  includeOptionOverrides?: boolean;
}

/**
 * Freeform mode select styles.
 * Used by PlayerSelectStep and MovementTypeStep.
 */
export const getFreeformSelectStyles = (
  options: FreeformSelectStylesOptions = {},
) => {
  const { includeOptionOverrides = true } = options;

  const base = {
    ...darkThemeSelectStyles,
    control: (provided: any, state: any) => ({
      ...darkThemeSelectStyles.control(provided, state),
      backgroundColor: state.isDisabled ? "#2A2A2C" : "#0b0b0b",
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      borderRadius: "8px",
      height: "36px",
      minHeight: "36px",
      borderColor: "#2a2a2a",
      borderWidth: "0.833px",
    }),
    menuList: (provided: any) => ({
      ...darkThemeSelectStyles.menuList(provided),
      maxHeight: 320,
    }),
  };

  if (includeOptionOverrides) {
    base.option = (provided: any, state: any) => ({
      ...darkThemeSelectStyles.option(provided, state),
      backgroundColor: state.isFocused ? "#2A2A2C" : "#1D1D1F",
      color: state.isSelected ? "#fb6a07" : "#f7f7f9",
      "&:hover": {
        backgroundColor: "#2A2A2C",
      },
      "&:active": {
        backgroundColor: "#2A2A2C",
      },
    });
  }

  return base;
};
